import { FC, ReactNode } from 'react'
import { UploadOutlined } from '@ant-design/icons'
import { Button, Form, Upload } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { Rule } from 'antd/es/form'
import { UploadProps } from 'antd/es/upload'

interface UploadFileProps {
    name: NamePath
    label: ReactNode
    extra?: string
    rules?: Rule[]
    disabled?: boolean
    multiple?: boolean
    accept?: string
    beforeUpload?: UploadProps['beforeUpload']
}

const UploadFile: FC<UploadFileProps> = ({
    name,
    label,
    extra,
    rules,
    disabled,
    multiple,
    accept,
    beforeUpload,
}) => {
    const handleBeforeUpload: UploadProps['beforeUpload'] = async (file, fileList) => {
        if (beforeUpload) {
            const result = await beforeUpload(file, fileList)
            if (result === Upload.LIST_IGNORE) {
                return Upload.LIST_IGNORE
            }
        }
        return false
    }

    const normFile = (e: any) => {
        console.log('Upload event:', e)
        if (Array.isArray(e)) {
            return e
        }
        return e?.fileList
    }

    return (
        <>
            <Form.Item
                name={name}
                label={label}
                valuePropName='fileList'
                getValueFromEvent={normFile}
                rules={rules}
                extra={extra}
            >
                <Upload
                    name='files'
                    beforeUpload={handleBeforeUpload}
                    disabled={disabled}
                    multiple={multiple}
                    accept={accept}
                >
                    <Button icon={<UploadOutlined />} disabled={disabled}>
                        Загрузить
                    </Button>
                </Upload>
            </Form.Item>
        </>
    )
}

export default UploadFile

// type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0]

// const [fileList, setFileList] = useState<UploadFileType[]>([])
// const [uploading, setUploading] = useState(false)

// const handleUpload = async () => {
//     const formData = new FormData()
//     // console.log(fileList)
//     fileList.forEach(file => {
//         formData.append('files', file as FileType)
//     })
//     setUploading(true)
//     // You can use any AJAX library you like
//     const res = await fetch(import.meta.env.VITE_API_URL + '/upload', {
//         method: 'post',
//         credentials: 'include',
//         headers: { authorization: `Bearer ${tokenStorage.get()}` },
//         body: formData,
//     })

//     console.log(res)
// }

// const props: UploadProps = {
//     onRemove: file => {
//         const index = fileList.indexOf(file)
//         const newFileList = fileList.slice()
//         newFileList.splice(index, 1)
//         setFileList(newFileList)
//     },
//     beforeUpload: file => {
//         setFileList([...fileList, file])

//         return false
//     },
//     fileList,
// }

/* 1 способ */
/* <Upload {...props}>
                <Button icon={<UploadOutlined />}>Выбрать файл</Button>
            </Upload>
            <Button
                type='primary'
                onClick={handleUpload}
                disabled={fileList.length === 0}
                loading={uploading}
                style={{ marginTop: 16 }}
            >
                {uploading ? 'Uploading' : 'Start Upload'}
            </Button> */
